// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.general.location.IsPhrUrlCodeValidRequest */
/* istanbul ignore next */
@GandalfModel
export class IsPhrUrlCodeValidRequest extends GandalfModelBase {

	@GandalfLabel('PHR URL')
	@GandalfValidator({ notNull: { message: 'PHR URL is required' } })
	@GandalfValidator({ sizeString: { message: 'PHR URL must be between 3 and 30 characters', minLength: 3, maxLength: 30 } })
	@GandalfProperty({ designType: String, isRequired: true })
	phrUrlCode!: string;

}
